import { render } from "./search-project-card.vue?vue&type=template&id=552c1408&scoped=true"
import script from "./search-project-card.vue?vue&type=script&lang=js"
export * from "./search-project-card.vue?vue&type=script&lang=js"

import "./search-project-card.vue?vue&type=style&index=0&id=552c1408&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552c1408"]])

export default __exports__